(function () {

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireec24"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireec24"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $89d6dc4774fd8983$exports = {};
$parcel$extendImportMap({
    "aykjc": "pow_bg.ee20fe28.wasm",
    "lyHvT": "pow.worker.8e8e5abc.js"
});

// This file contains code adapted from https://github.com/TecharoHQ/anubis under the MIT License.
function $179141a1650d5b98$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $179141a1650d5b98$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $179141a1650d5b98$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $179141a1650d5b98$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $aad16fe3185693ba$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


var $c6014fe51146dc0b$var$extendStatics = function extendStatics1(d, b) {
    $c6014fe51146dc0b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $c6014fe51146dc0b$var$extendStatics(d, b);
};
function $c6014fe51146dc0b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $c6014fe51146dc0b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $c6014fe51146dc0b$export$18ce0697a983be9b = function __assign1() {
    $c6014fe51146dc0b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c6014fe51146dc0b$export$18ce0697a983be9b.apply(this, arguments);
};
function $c6014fe51146dc0b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $c6014fe51146dc0b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $aad16fe3185693ba$export$71511d61b312f219)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $c6014fe51146dc0b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $c6014fe51146dc0b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $aad16fe3185693ba$export$71511d61b312f219)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $c6014fe51146dc0b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $c6014fe51146dc0b$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $aad16fe3185693ba$export$71511d61b312f219)(x)) === "symbol" ? x : "".concat(x);
}
function $c6014fe51146dc0b$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $aad16fe3185693ba$export$71511d61b312f219)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $c6014fe51146dc0b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $aad16fe3185693ba$export$71511d61b312f219)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $c6014fe51146dc0b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c6014fe51146dc0b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $c6014fe51146dc0b$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $c6014fe51146dc0b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $c6014fe51146dc0b$export$45d3717a4c69092e(o, m, p);
}
function $c6014fe51146dc0b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $c6014fe51146dc0b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $c6014fe51146dc0b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($c6014fe51146dc0b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $c6014fe51146dc0b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $c6014fe51146dc0b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $c6014fe51146dc0b$export$10c90e4f7922046c(v) {
    return this instanceof $c6014fe51146dc0b$export$10c90e4f7922046c ? (this.v = v, this) : new $c6014fe51146dc0b$export$10c90e4f7922046c(v);
}
function $c6014fe51146dc0b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c6014fe51146dc0b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $c6014fe51146dc0b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c6014fe51146dc0b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $c6014fe51146dc0b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $c6014fe51146dc0b$export$19a8beecd37a4c45 === "function" ? $c6014fe51146dc0b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $c6014fe51146dc0b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $c6014fe51146dc0b$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $c6014fe51146dc0b$var$ownKeys = function ownKeys1(o) {
    $c6014fe51146dc0b$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $c6014fe51146dc0b$var$ownKeys(o);
};
function $c6014fe51146dc0b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $c6014fe51146dc0b$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $c6014fe51146dc0b$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $c6014fe51146dc0b$var$__setModuleDefault(result, mod);
    return result;
}
function $c6014fe51146dc0b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $c6014fe51146dc0b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $c6014fe51146dc0b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $c6014fe51146dc0b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $aad16fe3185693ba$export$71511d61b312f219)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $c6014fe51146dc0b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $aad16fe3185693ba$export$71511d61b312f219)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $c6014fe51146dc0b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $c6014fe51146dc0b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $c6014fe51146dc0b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $c6014fe51146dc0b$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $c6014fe51146dc0b$export$2e2bcd8739ae039 = {
    __extends: $c6014fe51146dc0b$export$a8ba968b8961cb8a,
    __assign: $c6014fe51146dc0b$export$18ce0697a983be9b,
    __rest: $c6014fe51146dc0b$export$3c9a16f847548506,
    __decorate: $c6014fe51146dc0b$export$29e00dfd3077644b,
    __param: $c6014fe51146dc0b$export$d5ad3fd78186038f,
    __esDecorate: $c6014fe51146dc0b$export$3a84e1ae4e97e9b0,
    __runInitializers: $c6014fe51146dc0b$export$d831c04e792af3d,
    __propKey: $c6014fe51146dc0b$export$6a2a36740a146cb8,
    __setFunctionName: $c6014fe51146dc0b$export$d1a06452d3489bc7,
    __metadata: $c6014fe51146dc0b$export$f1db080c865becb9,
    __awaiter: $c6014fe51146dc0b$export$1050f835b63b671e,
    __generator: $c6014fe51146dc0b$export$67ebef60e6f28a6,
    __createBinding: $c6014fe51146dc0b$export$45d3717a4c69092e,
    __exportStar: $c6014fe51146dc0b$export$f33643c0debef087,
    __values: $c6014fe51146dc0b$export$19a8beecd37a4c45,
    __read: $c6014fe51146dc0b$export$8d051b38c9118094,
    __spread: $c6014fe51146dc0b$export$afc72e2116322959,
    __spreadArrays: $c6014fe51146dc0b$export$6388937ca91ccae8,
    __spreadArray: $c6014fe51146dc0b$export$1216008129fb82ed,
    __await: $c6014fe51146dc0b$export$10c90e4f7922046c,
    __asyncGenerator: $c6014fe51146dc0b$export$e427f37a30a4de9b,
    __asyncDelegator: $c6014fe51146dc0b$export$bbd80228419bb833,
    __asyncValues: $c6014fe51146dc0b$export$e3b29a3d6162315f,
    __makeTemplateObject: $c6014fe51146dc0b$export$4fb47efe1390b86f,
    __importStar: $c6014fe51146dc0b$export$c21735bcef00d192,
    __importDefault: $c6014fe51146dc0b$export$da59b14a69baef04,
    __classPrivateFieldGet: $c6014fe51146dc0b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $c6014fe51146dc0b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $c6014fe51146dc0b$export$81fdc39f203e4e04,
    __addDisposableResource: $c6014fe51146dc0b$export$88ac25d8e944e405,
    __disposeResources: $c6014fe51146dc0b$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $c6014fe51146dc0b$export$889dfb5d17574b0b
};


// This file contains code adapted from https://github.com/TecharoHQ/anubis under the MIT License.


var $6136de73d0bea42d$exports = {};
$6136de73d0bea42d$exports = $parcel$resolve("aykjc");


function $2b9a098d94c679e8$export$2e2bcd8739ae039(data) {
    return $2b9a098d94c679e8$var$_process.apply(this, arguments);
}
var $60b7b4dec337db04$exports = {};
var $06ba7be832f201c7$exports = {};
"use strict";
$06ba7be832f201c7$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};


var $60b7b4dec337db04$var$url = new URL($parcel$resolve("lyHvT"));
$60b7b4dec337db04$exports = $06ba7be832f201c7$exports($60b7b4dec337db04$var$url.toString(), $60b7b4dec337db04$var$url.origin, false);


function $2b9a098d94c679e8$var$_process() {
    $2b9a098d94c679e8$var$_process = (0, $179141a1650d5b98$export$71511d61b312f219)(function(data) {
        var difficulty, signal, progressCallback, threads;
        var _arguments = arguments;
        return (0, $c6014fe51146dc0b$export$67ebef60e6f28a6)(this, function(_state) {
            difficulty = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 5, signal = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : null, progressCallback = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : null, threads = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : navigator.hardwareConcurrency || 1;
            return [
                2,
                new Promise(function(resolve, reject) {
                    console.debug("fast algo");
                    var workers = [];
                    var terminate = function() {
                        workers.forEach(function(w) {
                            return w.terminate();
                        });
                        if (signal !== null) {
                            // clean up listener to avoid memory leak
                            signal.removeEventListener("abort", terminate);
                            if (signal.aborted) {
                                console.log("PoW aborted");
                                reject(new Error("PoW aborted"));
                            }
                        }
                    };
                    if (signal !== null) signal.addEventListener("abort", terminate, {
                        once: true
                    });
                    (0, $179141a1650d5b98$export$71511d61b312f219)(function() {
                        var wasmModule, i, worker;
                        return (0, $c6014fe51146dc0b$export$67ebef60e6f28a6)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        fetch((0, (/*@__PURE__*/$parcel$interopDefault($6136de73d0bea42d$exports))))
                                    ];
                                case 1:
                                    return [
                                        4,
                                        _state.sent().arrayBuffer()
                                    ];
                                case 2:
                                    wasmModule = _state.sent();
                                    for(i = 0; i < threads; i++){
                                        worker = new Worker($60b7b4dec337db04$exports);
                                        worker.onmessage = function(event) {
                                            if (typeof event.data === "number") progressCallback === null || progressCallback === void 0 ? void 0 : progressCallback(event.data);
                                            else {
                                                terminate();
                                                resolve(event.data);
                                            }
                                        };
                                        worker.onerror = function(event) {
                                            terminate();
                                            reject(event);
                                        };
                                        worker.postMessage({
                                            wasmModule: wasmModule,
                                            data: data,
                                            difficulty: difficulty,
                                            nonce: i,
                                            threads: threads
                                        });
                                        workers.push(worker);
                                    }
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                })
            ];
        });
    });
    return $2b9a098d94c679e8$var$_process.apply(this, arguments);
}


/**
 * A collection of runtime utility functions
 *
 * @remarks
 * This package should be marked as a dependency for any package that publishes the output of {@link @messageformat/core#compileModule},
 * as it may be included in its ES module source output as a dependency.
 *
 * For applications that bundle their output using e.g. Webpack this is not necessary.
 *
 * The `Messages` accessor class is a completely optional addition.
 * See also {@link @messageformat/react# | @messageformat/react} for a React-specific solution.
 *
 * @packageDocumentation
 */ /**
 * Accessor class for compiled message functions generated by
 * {@link @messageformat/core#compileModule}
 *
 * @public
 * @remarks
 * ```js
 * import Messages from '@messageformat/runtime/messages'
 * ```
 *
 * @example
 * ```js
 * // build.js
 * import { writeFileSync } from 'fs';
 * import MessageFormat from '@messageformat/core';
 * import compileModule from '@messageformat/core/compile-module'
 *
 * const mf = new MessageFormat(['en', 'fi']);
 * const msgSet = {
 *   en: {
 *     a: 'A {TYPE} example.',
 *     b: 'This has {COUNT, plural, one{one user} other{# users}}.',
 *     c: {
 *       d: 'We have {P, number, percent} code coverage.'
 *     }
 *   },
 *   fi: {
 *     b: 'Tällä on {COUNT, plural, one{yksi käyttäjä} other{# käyttäjää}}.',
 *     e: 'Minä puhun vain suomea.'
 *   }
 * };
 * writeFileSync('messages.js', compileModule(mf, msgSet));
 * ```
 *
 * ```js
 * // runtime.js
 * import Messages from '@messageformat/runtime/messages';
 * import msgData from './messages';
 *
 * const messages = new Messages(msgData, 'en');
 *
 * messages.hasMessage('a')                // true
 * messages.hasObject('c')                 // true
 * messages.get('b', { COUNT: 3 })         // 'This has 3 users.'
 * messages.get(['c', 'd'], { P: 0.314 })  // 'We have 31% code coverage.'
 *
 * messages.get('e')                       // 'e'
 * messages.setFallback('en', ['foo', 'fi'])
 * messages.get('e')                       // 'Minä puhun vain suomea.'
 *
 * messages.locale = 'fi'
 * messages.hasMessage('a')                // false
 * messages.hasMessage('a', 'en')          // true
 * messages.hasMessage('a', null, true)    // true
 * messages.hasObject('c')                 // false
 * messages.get('b', { COUNT: 3 })         // 'Tällä on 3 käyttäjää.'
 * messages.get('c').d({ P: 0.628 })       // 'We have 63% code coverage.'
 * ```
 */ 
var $7d2dbc41645dbcab$var$Messages = /** @class */ function() {
    /**
     * @param msgData - A map of locale codes to their function objects
     * @param defaultLocale - If not defined, default and initial locale is the first key of `msgData`
     */ function Messages(msgData, defaultLocale) {
        var _this = this;
        /** @internal */ this._data = {};
        /** @internal */ this._fallback = {};
        /** @internal */ this._defaultLocale = null;
        /** @internal */ this._locale = null;
        Object.keys(msgData).forEach(function(lc) {
            if (lc !== 'toString') {
                _this._data[lc] = msgData[lc];
                if (defaultLocale === undefined) defaultLocale = lc;
            }
        });
        this.locale = defaultLocale || null;
        this._defaultLocale = this.locale;
    }
    Object.defineProperty(Messages.prototype, "availableLocales", {
        /** Read-only list of available locales */ get: function get() {
            return Object.keys(this._data);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Messages.prototype, "locale", {
        /**
         * Current locale
         *
         * @remarks
         * One of {@link Messages.availableLocales} or `null`.
         * Partial matches of language tags are supported, so e.g. with an `en` locale defined, it will be selected by `messages.locale = 'en-US'` and vice versa.
         */ get: function get() {
            return this._locale;
        },
        set: function set(locale) {
            this._locale = this.resolveLocale(locale);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Messages.prototype, "defaultLocale", {
        /**
         * Default fallback locale
         *
         * @remarks
         * One of {@link Messages.availableLocales} or `null`.
         * Partial matches of language tags are supported, so e.g. with an `en` locale defined, it will be selected by `messages.defaultLocale = 'en-US'` and vice versa.
         */ get: function get() {
            return this._defaultLocale;
        },
        set: function set(locale) {
            this._defaultLocale = this.resolveLocale(locale);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Add new messages to the accessor; useful if loading data dynamically
     *
     * @remarks
     * The locale code `lc` should be an exact match for the locale being updated, or empty to default to the current locale.
     * Use {@link Messages.resolveLocale} for resolving partial locale strings.
     *
     * If `keypath` is empty, adds or sets the complete message object for the corresponding locale.
     * If any keys in `keypath` do not exist, a new object will be created at that key.
     *
     * @param data - Hierarchical map of keys to functions, or a single message function
     * @param locale - If empty or undefined, defaults to `this.locale`
     * @param keypath - The keypath being added
     */ Messages.prototype.addMessages = function(data, locale, keypath) {
        var lc = locale || String(this.locale);
        if (typeof data !== 'function') data = Object.keys(data).reduce(function(map, key) {
            if (key !== 'toString') map[key] = data[key];
            return map;
        }, {});
        if (Array.isArray(keypath) && keypath.length > 0) {
            var parent_1 = this._data[lc];
            for(var i = 0; i < keypath.length - 1; ++i){
                var key = keypath[i];
                if (!parent_1[key]) parent_1[key] = {};
                parent_1 = parent_1[key];
            }
            parent_1[keypath[keypath.length - 1]] = data;
        } else this._data[lc] = data;
        return this;
    };
    /**
     * Resolve `lc` to the key of an available locale or `null`, allowing for partial matches.
     *
     * @remarks
     * For example, with an `en` locale defined, it will be selected by `messages.defaultLocale = 'en-US'` and vice versa.
     */ Messages.prototype.resolveLocale = function(locale) {
        var lc = String(locale);
        if (this._data[lc]) return locale;
        if (locale) {
            while(lc = lc.replace(/[-_]?[^-_]*$/, '')){
                if (this._data[lc]) return lc;
            }
            var ll = this.availableLocales;
            var re = new RegExp('^' + locale + '[-_]');
            for(var i = 0; i < ll.length; ++i){
                if (re.test(ll[i])) return ll[i];
            }
        }
        return null;
    };
    /**
     * Get the list of fallback locales
     *
     * @param locale - If empty or undefined, defaults to `this.locale`
     */ Messages.prototype.getFallback = function(locale) {
        var lc = locale || String(this.locale);
        return this._fallback[lc] || (lc === this.defaultLocale || !this.defaultLocale ? [] : [
            this.defaultLocale
        ]);
    };
    /**
     * Set the fallback locale or locales for `lc`
     *
     * @remarks
     * To disable fallback for the locale, use `setFallback(lc, [])`.
     * To use the default fallback, use `setFallback(lc, null)`.
     */ Messages.prototype.setFallback = function(lc, fallback) {
        this._fallback[lc] = Array.isArray(fallback) ? fallback : null;
        return this;
    };
    /**
     * Check if `key` is a message function for the locale
     *
     * @remarks
     * `key` may be a `string` for functions at the root level, or `string[]` for
     * accessing hierarchical objects. If an exact match is not found and
     * `fallback` is true, the fallback locales are checked for the first match.
     *
     * @param key - The key or keypath being sought
     * @param locale - If empty or undefined, defaults to `this.locale`
     * @param fallback - If true, also checks fallback locales
     */ Messages.prototype.hasMessage = function(key, locale, fallback) {
        var lc = locale || String(this.locale);
        var fb = fallback ? this.getFallback(lc) : null;
        return $7d2dbc41645dbcab$var$_has(this._data, lc, key, fb, 'function');
    };
    /**
     * Check if `key` is a message object for the locale
     *
     * @remarks
     * `key` may be a `string` for functions at the root level, or `string[]` for
     * accessing hierarchical objects. If an exact match is not found and
     * `fallback` is true, the fallback locales are checked for the first match.
     *
     * @param key - The key or keypath being sought
     * @param locale - If empty or undefined, defaults to `this.locale`
     * @param fallback - If true, also checks fallback locales
     */ Messages.prototype.hasObject = function(key, locale, fallback) {
        var lc = locale || String(this.locale);
        var fb = fallback ? this.getFallback(lc) : null;
        return $7d2dbc41645dbcab$var$_has(this._data, lc, key, fb, 'object');
    };
    /**
     * Get the message or object corresponding to `key`
     *
     * @remarks
     * `key` may be a `string` for functions at the root level, or `string[]` for accessing hierarchical objects.
     * If an exact match is not found, the fallback locales are checked for the first match.
     *
     * If `key` maps to a message function, the returned value will be the result of calling it with `props`.
     * If it maps to an object, the object is returned directly.
     * If nothing is found, `key` is returned.
     *
     * @param key - The key or keypath being sought
     * @param props - Optional properties passed to the function
     * @param lc - If empty or undefined, defaults to `this.locale`
     */ Messages.prototype.get = function(key, props, locale) {
        var lc = locale || String(this.locale);
        var msg = $7d2dbc41645dbcab$var$_get(this._data[lc], key);
        if (msg) return typeof msg == 'function' ? msg(props) : msg;
        var fb = this.getFallback(lc);
        for(var i = 0; i < fb.length; ++i){
            msg = $7d2dbc41645dbcab$var$_get(this._data[fb[i]], key);
            if (msg) return typeof msg == 'function' ? msg(props) : msg;
        }
        return key;
    };
    return Messages;
}();
var $7d2dbc41645dbcab$export$2e2bcd8739ae039 = $7d2dbc41645dbcab$var$Messages;
function $7d2dbc41645dbcab$var$_get(obj, key) {
    if (!obj) return null;
    var res = obj;
    if (Array.isArray(key)) {
        for(var i = 0; i < key.length; ++i){
            if ((typeof res === "undefined" ? "undefined" : (0, $aad16fe3185693ba$export$71511d61b312f219)(res)) !== 'object') return null;
            res = res[key[i]];
            if (!res) return null;
        }
        return res;
    }
    return (typeof res === "undefined" ? "undefined" : (0, $aad16fe3185693ba$export$71511d61b312f219)(res)) === 'object' ? res[key] : null;
}
function $7d2dbc41645dbcab$var$_has(data, lc, key, fallback, type) {
    var msg = $7d2dbc41645dbcab$var$_get(data[lc], key);
    if (msg) return (typeof msg === "undefined" ? "undefined" : (0, $aad16fe3185693ba$export$71511d61b312f219)(msg)) === type;
    if (fallback) for(var i = 0; i < fallback.length; ++i){
        msg = $7d2dbc41645dbcab$var$_get(data[fallback[i]], key);
        if (msg) return (typeof msg === "undefined" ? "undefined" : (0, $aad16fe3185693ba$export$71511d61b312f219)(msg)) === type;
    }
    return false;
}


var $2442b2bff5a8bcca$export$2e2bcd8739ae039 = {
    zh: {
        challenge: {
            title: function() {
                return "\u9A8C\u8BC1\u60A8\u4E0D\u662F\u673A\u5668\u4EBA";
            },
            calculating: function() {
                return "\u6B63\u5728\u8FDB\u884C\u6D4F\u89C8\u5668\u68C0\u67E5...";
            },
            difficulty_speed: function(d) {
                return "\u96BE\u5EA6\uFF1A" + d.difficulty + "\uFF0C\u901F\u5EA6\uFF1A" + d.speed + "kH/s";
            },
            taking_longer: function() {
                return "\u9A8C\u8BC1\u65F6\u95F4\u8D85\u51FA\u9884\u671F\uFF0C\u8BF7\u52FF\u5237\u65B0\u9875\u9762";
            },
            why_seeing: function() {
                return "\u4E3A\u4EC0\u4E48\u6211\u4F1A\u770B\u5230\u8FD9\u4E2A\u9875\u9762\uFF1F";
            },
            why_seeing_body: {
                part_1: function(d) {
                    return "\u60A8\u770B\u5230\u8FD9\u4E2A\u9875\u9762\u662F\u56E0\u4E3A\u7F51\u7AD9\u7BA1\u7406\u5458\u542F\u7528\u4E86 " + d.cerberus + " \u6765\u9632\u5FA1\u5F02\u5E38\u6D41\u91CF\u653B\u51FB\u3002\u8FD9\u7C7B\u653B\u51FB\u53EF\u80FD\u5BFC\u81F4\u7F51\u7AD9\u670D\u52A1\u4E2D\u65AD\uFF0C\u5F71\u54CD\u6240\u6709\u7528\u6237\u7684\u6B63\u5E38\u8BBF\u95EE\u3002";
                },
                part_2: function(d) {
                    return "\u5982\u679C\u60A8\u4E86\u89E3 " + d.techaro + " \u5F00\u53D1\u7684 " + d.anubis + "\uFF0C\u90A3\u4E48 Cerberus \u91C7\u7528\u4E86\u7C7B\u4F3C\u7684 PoW \u9A8C\u8BC1\u6280\u672F\u3002\u4E0D\u540C\u7684\u662F\uFF0CAnubis \u4E3B\u8981\u9488\u5BF9 AI \u722C\u866B\uFF0C\u800C Cerberus \u5219\u91C7\u7528\u4E86\u66F4\u6FC0\u8FDB\u7684\u7B56\u7565\u6765\u4FDD\u62A4\u6211\u4EEC\u7684\u5F00\u6E90\u57FA\u7840\u8BBE\u65BD\u3002";
                },
                part_3: function(d) {
                    return "\u8BF7\u6CE8\u610F\uFF0CCerberus \u9700\u8981\u542F\u7528\u73B0\u4EE3 JavaScript \u529F\u80FD\uFF0C\u800C " + d.jshelter + " \u7B49\u63D2\u4EF6\u4F1A\u7981\u7528\u8FD9\u4E9B\u529F\u80FD\u3002\u8BF7\u4E3A\u672C\u57DF\u540D\u7981\u7528 " + d.jshelter + " \u6216\u7C7B\u4F3C\u7684\u63D2\u4EF6\u3002";
                }
            },
            must_enable_js: function() {
                return "\u8BF7\u542F\u7528 JavaScript \u4EE5\u7EE7\u7EED\u8BBF\u95EE";
            }
        },
        success: {
            title: function() {
                return "\u9A8C\u8BC1\u6210\u529F";
            },
            verification_complete: function() {
                return "\u9A8C\u8BC1\u5DF2\u5B8C\u6210";
            },
            took_time_iterations: function(d) {
                return "\u7528\u65F6 " + d.time + "ms\uFF0C\u5B8C\u6210 " + d.iterations + " \u6B21\u8FED\u4EE3";
            }
        },
        error: {
            error_occurred: function() {
                return "\u53D1\u751F\u9519\u8BEF";
            },
            access_restricted: function() {
                return "\u8BBF\u95EE\u53D7\u9650";
            },
            browser_config_or_bug: function() {
                return "\u53EF\u80FD\u662F\u6D4F\u89C8\u5668\u914D\u7F6E\u95EE\u9898\uFF0C\u4E5F\u53EF\u80FD\u662F\u6211\u4EEC\u7684\u7CFB\u7EDF\u51FA\u73B0\u4E86\u5F02\u5E38";
            },
            ip_blocked: function() {
                return "\u7531\u4E8E\u68C0\u6D4B\u5230\u53EF\u7591\u6D3B\u52A8\uFF0C\u60A8\u7684 IP \u5730\u5740\u6216\u672C\u5730\u7F51\u7EDC\u5DF2\u88AB\u5C01\u7981";
            },
            wait_before_retry: function() {
                return "\u8BF7\u7A0D\u540E\u518D\u8BD5\uFF0C\u67D0\u4E9B\u60C5\u51B5\u4E0B\u53EF\u80FD\u9700\u8981\u7B49\u5F85\u6570\u5C0F\u65F6";
            },
            contact_us: function(d) {
                return "\u5982\u6709\u95EE\u9898\uFF0C\u8BF7\u901A\u8FC7 " + d.mail + " \u8054\u7CFB\u6211\u4EEC";
            }
        },
        footer: {
            author: function(d) {
                return "\u7531 " + d.sjtug + " \u5F00\u53D1\u7684 " + d.cerberus + " \u63D0\u4F9B\u4FDD\u62A4";
            },
            upstream: function(d) {
                return "\u7075\u611F\u6765\u6E90\u4E8E \uD83C\uDDE8\uD83C\uDDE6 " + d.techaro + " \u5F00\u53D1\u7684 " + d.anubis;
            }
        }
    },
    en: {
        challenge: {
            title: function() {
                return "Making sure you're not a bot!";
            },
            calculating: function() {
                return "Performing browser checks...";
            },
            difficulty_speed: function(d) {
                return "Difficulty: " + d.difficulty + ", Speed: " + d.speed + "kH/s";
            },
            taking_longer: function() {
                return "This is taking longer than expected. Please do not refresh the page.";
            },
            why_seeing: function() {
                return "Why am I seeing this?";
            },
            why_seeing_body: {
                part_1: function(d) {
                    return "You are seeing this because the administrator of this website has set up " + d.cerberus + " to protect the server against abusive traffic. This can and does cause downtime for the websites, which makes their resources inaccessible for everyone.";
                },
                part_2: function(d) {
                    return "If you're familiar with " + d.anubis + " by " + d.techaro + ", Cerberus is similar - it performs a PoW challenge to verify the request. While Anubis focuses on protecting websites from AI scrapers, Cerberus takes a much more aggressive approach to protect our open-source infrastructure.";
                },
                part_3: function(d) {
                    return "Please note that Cerberus requires the use of modern JavaScript features that plugins like " + d.jshelter + " will disable. Please disable " + d.jshelter + " or other such plugins for this domain.";
                }
            },
            must_enable_js: function() {
                return "You must enable JavaScript to proceed.";
            }
        },
        success: {
            title: function() {
                return "Success!";
            },
            verification_complete: function() {
                return "Verification Complete!";
            },
            took_time_iterations: function(d) {
                return "Took " + d.time + "ms, " + d.iterations + " iterations";
            }
        },
        error: {
            error_occurred: function() {
                return "Error occurred while processing your request";
            },
            access_restricted: function() {
                return "Access has been restricted";
            },
            browser_config_or_bug: function() {
                return "There might be an issue with your browser configuration, or something is wrong on our side.";
            },
            ip_blocked: function() {
                return "You (or your local network) have been blocked due to suspicious activity.";
            },
            wait_before_retry: function() {
                return "Please wait a while before you try again; in some cases this may take a few hours.";
            },
            contact_us: function(d) {
                return "If you believe this is an error, please contact us at " + d.mail + ".";
            }
        },
        footer: {
            author: function(d) {
                return "Protected by " + d.cerberus + " from " + d.sjtug + ".";
            },
            upstream: function(d) {
                return "Heavily inspired by " + d.anubis + " from " + d.techaro + " in \uD83C\uDDE8\uD83C\uDDE6.";
            }
        }
    }
};


var $879896b395956ce6$var$messages = new (0, $7d2dbc41645dbcab$export$2e2bcd8739ae039)((0, $2442b2bff5a8bcca$export$2e2bcd8739ae039));
console.log($879896b395956ce6$var$messages.locale, $879896b395956ce6$var$messages.availableLocales);
function $879896b395956ce6$var$t(key, props) {
    return $879896b395956ce6$var$messages.get(key.split('.'), props);
}
var $879896b395956ce6$var$meta = {
    baseURL: "",
    version: "",
    locale: ""
};
var $879896b395956ce6$var$dom = {
    title: document.getElementById('title'),
    mascot: document.getElementById('mascot'),
    status: document.getElementById('status'),
    metrics: document.getElementById('metrics'),
    message: document.getElementById('message'),
    progressContainer: document.getElementById('progress-container'),
    progressBar: document.getElementById('progress-bar')
};
var $879896b395956ce6$var$ui = {
    title: function(title) {
        return $879896b395956ce6$var$dom.title.textContent = title;
    },
    mascotState: function(state) {
        return $879896b395956ce6$var$dom.mascot.src = "".concat($879896b395956ce6$var$meta.baseURL, "/static/img/mascot-").concat(state, ".png?v=").concat($879896b395956ce6$var$meta.version);
    },
    status: function(status) {
        return $879896b395956ce6$var$dom.status.textContent = status;
    },
    metrics: function(metrics) {
        return $879896b395956ce6$var$dom.metrics.textContent = metrics;
    },
    message: function(message) {
        return $879896b395956ce6$var$dom.message.textContent = message;
    },
    progress: function(progress) {
        $879896b395956ce6$var$dom.progressContainer.classList.toggle('hidden', !progress);
        $879896b395956ce6$var$dom.progressBar.style.width = "".concat(progress, "%");
    }
};
function $879896b395956ce6$var$createAnswerForm(hash, solution, baseURL, nonce, ts, signature) {
    function addHiddenInput(form, name, value) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.appendChild(input);
    }
    var form = document.createElement('form');
    form.method = 'POST';
    form.action = "".concat(baseURL, "/answer");
    addHiddenInput(form, 'response', hash);
    addHiddenInput(form, 'solution', solution);
    addHiddenInput(form, 'nonce', nonce);
    addHiddenInput(form, 'ts', ts);
    addHiddenInput(form, 'signature', signature);
    addHiddenInput(form, 'redir', window.location.href);
    document.body.appendChild(form);
    return form;
}
(0, $179141a1650d5b98$export$71511d61b312f219)(function() {
    var thisScript, _JSON_parse, challenge, difficulty, inputNonce, ts, signature, _JSON_parse1, baseURL, version, locale, t0, lastUpdate, likelihood, mergedChallenge, _ref, hash, solution, t1, form;
    return (0, $c6014fe51146dc0b$export$67ebef60e6f28a6)(this, function(_state) {
        switch(_state.label){
            case 0:
                // const image = document.getElementById('image');
                // const spinner = document.getElementById('spinner');
                // const anubisVersion = JSON.parse(document.getElementById('anubis_version').textContent);
                thisScript = document.getElementById('challenge-script');
                _JSON_parse = JSON.parse(thisScript.getAttribute('x-challenge')), challenge = _JSON_parse.challenge, difficulty = _JSON_parse.difficulty, inputNonce = _JSON_parse.nonce, ts = _JSON_parse.ts, signature = _JSON_parse.signature;
                _JSON_parse1 = JSON.parse(thisScript.getAttribute('x-meta')), baseURL = _JSON_parse1.baseURL, version = _JSON_parse1.version, locale = _JSON_parse1.locale;
                // Initialize UI
                $879896b395956ce6$var$meta.baseURL = baseURL;
                $879896b395956ce6$var$meta.version = version;
                $879896b395956ce6$var$meta.locale = locale;
                // Set locale
                $879896b395956ce6$var$messages.locale = locale;
                // Set initial checking state
                $879896b395956ce6$var$ui.title($879896b395956ce6$var$t('challenge.title'));
                $879896b395956ce6$var$ui.mascotState('puzzle');
                $879896b395956ce6$var$ui.status($879896b395956ce6$var$t('challenge.calculating'));
                $879896b395956ce6$var$ui.metrics($879896b395956ce6$var$t('challenge.difficulty_speed', {
                    difficulty: difficulty,
                    speed: 0
                }));
                $879896b395956ce6$var$ui.message('');
                $879896b395956ce6$var$ui.progress(0);
                t0 = Date.now();
                lastUpdate = 0;
                likelihood = Math.pow(16, -difficulty / 2);
                mergedChallenge = "".concat(challenge, "|").concat(inputNonce, "|").concat(ts, "|").concat(signature, "|");
                return [
                    4,
                    (0, $2b9a098d94c679e8$export$2e2bcd8739ae039)(mergedChallenge, difficulty, null, function(iters) {
                        // the probability of still being on the page is (1 - likelihood) ^ iters.
                        // by definition, half of the time the progress bar only gets to half, so
                        // apply a polynomial ease-out function to move faster in the beginning
                        // and then slow down as things get increasingly unlikely. quadratic felt
                        // the best in testing, but this may need adjustment in the future.
                        var probability = Math.pow(1 - likelihood, iters);
                        var distance = (1 - Math.pow(probability, 2)) * 100;
                        // Update progress every 200ms
                        var now = Date.now();
                        var delta = now - t0;
                        if (delta - lastUpdate > 200) {
                            var speed = iters / delta;
                            $879896b395956ce6$var$ui.progress(distance);
                            $879896b395956ce6$var$ui.metrics($879896b395956ce6$var$t('challenge.difficulty_speed', {
                                difficulty: difficulty,
                                speed: speed.toFixed(3)
                            }));
                            $879896b395956ce6$var$ui.message(probability < 0.01 ? $879896b395956ce6$var$t('challenge.taking_longer') : undefined);
                            lastUpdate = delta;
                        }
                    })
                ];
            case 1:
                _ref = _state.sent(), hash = _ref.hash, solution = _ref.nonce;
                t1 = Date.now();
                console.log({
                    hash: hash,
                    solution: solution
                });
                // Show success state
                $879896b395956ce6$var$ui.title($879896b395956ce6$var$t('success.title'));
                $879896b395956ce6$var$ui.mascotState('pass');
                $879896b395956ce6$var$ui.status($879896b395956ce6$var$t('success.verification_complete'));
                $879896b395956ce6$var$ui.metrics($879896b395956ce6$var$t('success.took_time_iterations', {
                    time: t1 - t0,
                    iterations: solution
                }));
                $879896b395956ce6$var$ui.message('');
                $879896b395956ce6$var$ui.progress(0);
                form = $879896b395956ce6$var$createAnswerForm(hash, solution, baseURL, inputNonce, ts, signature);
                setTimeout(function() {
                    form.submit();
                }, 250);
                return [
                    2
                ];
        }
    });
})();

})();
//# sourceMappingURL=main.js.map
